import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const addSymbolSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
        <g fill="none" fillRule="evenodd">
            <path stroke="currentColor" d="M13 22.5H5.5a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2V14"></path>
            <path stroke="currentColor" strokeLinecap="square" d="M18.5 15.5v8m-4-4h8"></path>
            <path fill="currentColor" d="M7 8h11v1H7zm0 4h11v1H7zm0 4h5v1H7z"></path>
        </g>
    </svg>
)

const AddSymbol: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {addSymbolSvg}
    </SvgIcon>
)

export default AddSymbol